type BreakPhraseInTwo = (text: string) => string[];

export const breakPhraseInTwo: BreakPhraseInTwo = (text) => {
	const textLength = text.length;
	const middleIndex = Math.floor(textLength / 2);

	const middleCharacter = text.charAt(middleIndex);
	let breakIndex;

	// Check if middleCharacter is a space
	if (middleCharacter === ' ') {
		breakIndex = middleIndex;
	}

	// If not, find the next space after the middle index
	const nextSpaceIndex = text.indexOf(' ', middleIndex);
	if (breakIndex === undefined && nextSpaceIndex !== -1) {
		breakIndex = nextSpaceIndex;
	}
	// If no space is found, find the last space before the middle index
	const previousSpaceIndex = text.lastIndexOf(' ', middleIndex);
	if (breakIndex === undefined && previousSpaceIndex !== -1) {
		breakIndex = previousSpaceIndex;
	}

	// If a space is found, split the text
	if (breakIndex !== undefined) {
		return [text.slice(0, breakIndex), text.slice(breakIndex + 1)];
	}

	// If no space is found, return the original text
	return [text];
};
